/**
 * Tujuan: Navigation bar — fixed top, scroll-aware background, mobile collapse, active link highlight
 * Caller: App.js (rendered on every page)
 * Dependensi: react-bootstrap (Navbar, Nav, Container), react-router-dom (Link, useLocation), react-icons
 * Main Functions: NavBar()
 * Side Effects: window scroll event listener (registered via useEffect, cleaned up on unmount)
 */
import React, { useState, useEffect } from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import { Link, useLocation } from "react-router-dom";
import {
  AiOutlineHome,
  AiOutlineUser,
  AiOutlineFundProjectionScreen,
  AiOutlineSafetyCertificate,
} from "react-icons/ai";

function NavBar() {
  const [expand, setExpand] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  // Register scroll listener once on mount, clean up on unmount
  useEffect(() => {
    function handleScroll() {
      setScrolled(window.scrollY >= 20);
    }
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const isActive = (path) => location.pathname === path;

  const closeNav = () => setExpand(false);

  return (
    <Navbar
      expanded={expand}
      fixed="top"
      expand="md"
      className={scrolled ? "sticky" : "navbar"}
    >
      <Container>
        {/* Logo */}
        <Navbar.Brand as={Link} to="/" onClick={closeNav}>
          <strong className="main-name" style={{ fontSize: "1.4rem", letterSpacing: "0.02em" }}>
            NP<i style={{ color: "var(--blue-accent)" }}>i</i>
          </strong>
        </Navbar.Brand>

        {/* Mobile toggle */}
        <Navbar.Toggle
          aria-controls="responsive-navbar-nav"
          onClick={() => setExpand(expand ? false : "expanded")}
        >
          <span></span>
          <span></span>
          <span></span>
        </Navbar.Toggle>

        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ms-auto">

            <Nav.Item>
              <Nav.Link
                as={Link}
                to="/"
                className={isActive("/") ? "active" : ""}
                onClick={closeNav}
              >
                <AiOutlineHome style={{ marginBottom: "2px" }} /> Home
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                as={Link}
                to="/about"
                className={isActive("/about") ? "active" : ""}
                onClick={closeNav}
              >
                <AiOutlineUser style={{ marginBottom: "2px" }} /> About
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                as={Link}
                to="/project"
                className={location.pathname.startsWith("/project") ? "active" : ""}
                onClick={closeNav}
              >
                <AiOutlineFundProjectionScreen style={{ marginBottom: "2px" }} />{" "}
                Projects
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                as={Link}
                to="/certifications"
                className={isActive("/certifications") ? "active" : ""}
                onClick={closeNav}
              >
                <AiOutlineSafetyCertificate style={{ marginBottom: "2px" }} />{" "}
                Certifications
              </Nav.Link>
            </Nav.Item>

          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;
